import { useFetch } from "@/common/hooks/useFetch";
import { apiNiches } from "@/common/services";
import { useCallback, useMemo } from "react";
import { IGif } from "@/common/services/types";

interface IUseTaggedNiches {
  gifs: IGif[];
}

export const useGetRelatedNiches = ({ gifs }: IUseTaggedNiches) => {
  const niche = useMemo(() => {
    const items: { name: string; count: number }[] = [];

    gifs.forEach(gif => {
      if (!gif.tags) {
        return;
      }

      gif.niches.forEach(niche => {
        const index = items.findIndex((item) => item.name === niche);

        if (index === -1) {
          items.push({
            name: niche,
            count: 1,
          });
        } else {
          items[index].count++;
        }
      });
    });

    items.sort((a, b) => a.count - b.count);

    return items.length > 0 ? items[0].name : null;
  }, [gifs]);

  const fetchRelatedNiches = useCallback(async () => {
    if (niche === null) {
      return { niches: [] };
    }

    return await apiNiches.getRelatedNiches({ niche });
  }, [niche]);

  const { data, isLoading } = useFetch(fetchRelatedNiches);

  return {
    niches: data?.niches.slice(0, 4) || [],
    isLoading
  };
};
